export default "__VITE_ASSET__CDVGfPJa__"